
export default function TravelTips() {
  const tips = [
    {
      icon: 'ri-shield-check-line',
      title: '海外旅行保険の選び方',
      description: '自動付帯と利用付帯の違いを理解し、補償内容を確認しましょう。傷害死亡・後遺障害、傷害治療費用、疾病治療費用、賠償責任、携行品損害、救援者費用などの項目をチェック。',
      color: 'from-sky-500 to-cyan-500',
      bgColor: 'bg-sky-50',
    },
    {
      icon: 'ri-vip-crown-line',
      title: '空港ラウンジの活用',
      description: 'ゴールドカード以上で利用できる空港ラウンジ。フライト前の待ち時間を快適に過ごせます。国内主要空港のラウンジが無料で利用可能なカードを選びましょう。',
      color: 'from-amber-500 to-orange-500',
      bgColor: 'bg-amber-50',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '海外キャッシングの注意点',
      description: '現地通貨が必要な時に便利な海外キャッシング。ATM手数料や為替レートを確認し、帰国後は早めに返済することで利息を抑えられます。',
      color: 'from-emerald-500 to-teal-500',
      bgColor: 'bg-emerald-50',
    },
    {
      icon: 'ri-global-line',
      title: '海外での決済ブランド',
      description: 'Visa・Mastercardは世界中で使えますが、JCBは日本人観光客が多いエリアで特典が充実。複数ブランドを持っておくと安心です。',
      color: 'from-violet-500 to-purple-500',
      bgColor: 'bg-violet-50',
    },
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-14">
          <span className="inline-block bg-gradient-to-r from-sky-100 to-cyan-100 text-sky-700 px-4 py-1.5 rounded-full text-xs sm:text-sm font-bold mb-4">
            💡 海外旅行のコツ
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            海外旅行で<span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-600 to-cyan-600">クレカを活用</span>するポイント
          </h2>
          <p className="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto">
            海外旅行をより快適に、お得に楽しむためのクレジットカード活用術
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
          {tips.map((tip, index) => (
            <div
              key={index}
              className={`${tip.bgColor} rounded-2xl p-6 sm:p-8 border border-gray-100 hover:shadow-lg transition-all duration-300`}
            >
              <div className="flex items-start gap-4">
                <div className={`w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br ${tip.color} rounded-xl flex items-center justify-center flex-shrink-0 shadow-md`}>
                  <i className={`${tip.icon} text-white text-xl sm:text-2xl`}></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">
                    {tip.title}
                  </h3>
                  <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                    {tip.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 注意事項 */}
        <div className="mt-10 sm:mt-14 bg-white rounded-2xl border border-sky-200 p-6 sm:p-8">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-sky-100 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-information-line text-sky-600 text-xl sm:text-2xl"></i>
            </div>
            <div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">
                海外旅行前の準備チェックリスト
              </h3>
              <ul className="space-y-2 text-gray-600 text-sm sm:text-base">
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-sky-500"></i>
                  カードの有効期限を確認（旅行期間中に切れないか）
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-sky-500"></i>
                  海外旅行保険の補償内容と適用条件を確認
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-sky-500"></i>
                  カード会社の緊急連絡先をメモ
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-sky-500"></i>
                  暗証番号の確認（海外ATMで必要）
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-sky-500"></i>
                  利用限度額の確認・必要に応じて一時増額申請
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
